export const COLLECTION_VIEW_EVENT = 'figs_collection_view'
export const PDP_VIEW_EVENT = 'figs_product_view'
export const SOURCE_PLATFORM = 'web'
